'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCannedRule = exports.confirmEditCannedRule = exports.editCannedRule = exports.addCannedRule = exports.changeCannedRulesProperty = exports.CONFIRM_EDIT_CANNEDRULE = exports.DELETE_CANNEDRULE = exports.EDIT_CANNEDRULE = exports.ADD_CANNEDRULE = exports.CHANGE_PROPERTY = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_PROPERTY = exports.CHANGE_PROPERTY = 'tq-plus-admin/cannedRules/CHANGE_PROPERTY';

var ADD_CANNEDRULE = exports.ADD_CANNEDRULE = 'tq-plus-admin/cannedRules/ADD_CANNEDRULE';
var EDIT_CANNEDRULE = exports.EDIT_CANNEDRULE = 'tq-plus-admin/cannedRules/EDIT_CANNEDRULE';
var DELETE_CANNEDRULE = exports.DELETE_CANNEDRULE = 'tq-plus-admin/cannedRules/DELETE_CANNEDRULE';
var CONFIRM_EDIT_CANNEDRULE = exports.CONFIRM_EDIT_CANNEDRULE = 'tq-plus-admin/cannedRules/CONFIRM_EDIT_CANNEDRULE';

var initialState = {
  // Saved data
  current: [],
  // Data being modified
  temp: [],
  added: [],
  edited: [],
  removed: []
};

function editProperty(rules, index, values) {
  // Skip mutation, there's likely a neater way to achieve this
  // const ret = cloneDeep(rules);
  // Object.keys(values).forEach(value => (ret[index][value] = values[value]));
  // return ret;

  return [].concat((0, _toConsumableArray3.default)(rules.slice(0, index)), [// Take rules before the edited one
  (0, _extends5.default)({}, rules[index], values)], (0, _toConsumableArray3.default)(rules.slice(index + 1)));
}

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_PROPERTY:
      return (0, _extends5.default)({}, state, (0, _defineProperty3.default)({}, action.field, action.value));
    case _index.GET_GENERICSETTINGS_TYPES.SUCCESS:
      {
        var cannedRules = action.genericSettings && action.genericSettings.cannedRules || [];
        cannedRules.forEach(function (rule) {
          return rule.inDB = true;
        });

        return (0, _extends5.default)({}, state, {
          current: cannedRules,
          temp: cannedRules,
          added: [],
          edited: [],
          removed: []
        });
      }
    case ADD_CANNEDRULE:
      {
        var rule = (0, _extends5.default)({}, action.rule, { inDB: false });

        return (0, _extends5.default)({}, state, {
          temp: [].concat((0, _toConsumableArray3.default)(state.temp), [rule]),
          added: [].concat((0, _toConsumableArray3.default)(state.added), [rule])
        });
      }
    case EDIT_CANNEDRULE:
      {
        var index = state.temp.findIndex(function (item) {
          return item.id === action.id;
        });

        if (index > -1) {
          return (0, _extends5.default)({}, state, {
            temp: editProperty(state.temp, index, {
              editing: action.columnIndex
            })
          });
        }
        break;
      }
    case CONFIRM_EDIT_CANNEDRULE:
      {
        var indexConfirm = state.temp.findIndex(function (item) {
          return item.id === action.id;
        });

        if (indexConfirm > -1) {
          var _editProperty, _extends3;

          var addedIndex = state.added.findIndex(function (item) {
            return item.id === action.id;
          });
          var property = addedIndex > -1 ? 'added' : 'edited';
          var temp = editProperty(state.temp, indexConfirm, (_editProperty = {}, (0, _defineProperty3.default)(_editProperty, action.property, action.value), (0, _defineProperty3.default)(_editProperty, 'editing', false), _editProperty));

          var propertyIndex = addedIndex;
          if (addedIndex === -1) {
            propertyIndex = state.edited.findIndex(function (item) {
              return item.id === action.id;
            });
          }

          return (0, _extends5.default)({}, state, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, property, [].concat((0, _toConsumableArray3.default)(state[property].slice(0, propertyIndex)), [temp[indexConfirm]], (0, _toConsumableArray3.default)(state[property].slice(propertyIndex + 1)))), (0, _defineProperty3.default)(_extends3, 'temp', temp), _extends3));
        }
        break;
      }
    case DELETE_CANNEDRULE:
      {
        var tempIndex = state.temp.findIndex(function (item) {
          return item.id === action.id;
        });

        if (tempIndex > -1) {
          if (state.temp[tempIndex].inDB) {
            return (0, _extends5.default)({}, state, {
              removed: [].concat((0, _toConsumableArray3.default)(state.removed), [action.id]),
              temp: state.temp.slice(0, tempIndex).concat(state.temp.slice(tempIndex + 1))
            });
          } else {
            var _temp = void 0,
                added = void 0,
                edited = void 0,
                removed = void 0;

            _temp = state.temp.slice(0, tempIndex).concat(state.temp.slice(tempIndex + 1));

            var _addedIndex = state.added.findIndex(function (item) {
              return item.id === action.id;
            });
            if (_addedIndex > -1) {
              added = state.added.slice(0, _addedIndex).concat(state.added.slice(_addedIndex + 1));
            }

            var editedIndex = state.edited.findIndex(function (item) {
              return item.id === action.id;
            });
            if (editedIndex > -1) {
              added = state.edited.slice(0, editedIndex).concat(state.edited.slice(editedIndex + 1));
            }

            var removedIndex = state.removed.findIndex(function (item) {
              return item.id === action.id;
            });
            if (removedIndex > -1) {
              added = state.removed.slice(0, removedIndex).concat(state.removed.slice(removedIndex + 1));
            }

            return (0, _extends5.default)({}, state, {
              temp: _temp || state.temp,
              added: added || state.added,
              edited: edited || state.edited,
              removed: removed || state.removed
            });
          }
        }
        break;
      }
    case _index.CANCEL:
      {
        return (0, _extends5.default)({}, state, {
          temp: state.current,
          added: [],
          edited: [],
          removed: []
        });
      }
    default:
      return state;
  }
  return state;
}
/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var changeCannedRulesProperty = exports.changeCannedRulesProperty = function changeCannedRulesProperty(field, value) {
  return {
    type: CHANGE_PROPERTY, field: field, value: value
  };
};

var addCannedRule = exports.addCannedRule = function addCannedRule(rule) {
  return {
    type: ADD_CANNEDRULE, rule: rule
  };
};

var editCannedRule = exports.editCannedRule = function editCannedRule(columnIndex, id) {
  return {
    type: EDIT_CANNEDRULE, columnIndex: columnIndex, id: id
  };
};

var confirmEditCannedRule = exports.confirmEditCannedRule = function confirmEditCannedRule(property, value, id) {
  return {
    type: CONFIRM_EDIT_CANNEDRULE, property: property, value: value, id: id
  };
};

var deleteCannedRule = exports.deleteCannedRule = function deleteCannedRule(id) {
  return {
    type: DELETE_CANNEDRULE, id: id
  };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/cannedRules.js
// module id = 1653
// module chunks = 0